import React from 'react';
import Typography from '@latitude/typography';
import {
  Wrapper,
  SectionContainer,
  ImageSection,
  ItemBlock,
  StyledImage,
  MainWrapper,
  MobileTitleSection,
  DesktopTitleSection
} from './HowToApplyRebrandV2.styled';
import { REBRAND_COLOR } from '@latitude/core/utils/constants';

const HowToApplyV2 = ({ data, background }) => {
  const { howToApply, id, image } = data;

  return (
    <MainWrapper id={id} background={background}>
      <Wrapper>
        {/* Image Section */}
        <MobileTitleSection>
          <Typography.SH1 semibold>{howToApply.sectionTitle}</Typography.SH1>
        </MobileTitleSection>
        <ImageSection className='how-to-apply-image'>
          <StyledImage src={image} alt="How to apply" />
        </ImageSection>

        {/* How To Apply Section */}
        <SectionContainer>
          <DesktopTitleSection>
            <Typography.SH1 semibold>{howToApply.sectionTitle}</Typography.SH1>
          </DesktopTitleSection>

          {howToApply.items.map((item, index) => (
            <ItemBlock key={index}>
              <Typography.Body color={REBRAND_COLOR.INDIGO}>
                {item.title}
              </Typography.Body>

              <Typography.Body color={REBRAND_COLOR.INDIGO}>
                {item.description}
              </Typography.Body>
            </ItemBlock>
          ))}
        </SectionContainer>
      </Wrapper>
    </MainWrapper>
  );
};

export default HowToApplyV2;